import { takeEvery, put, delay } from 'redux-saga/effects';
import { exitDuperbrowseDone } from '@wix/da-shared-react/pkg/Duperbrowse/redux/actionCreators';
import { clearAllDrawerStreams, setDrawerFilter } from '../actions/drawer';
import { clearActiveRoomItem } from '../actions/room';

/**
 * Handles cleanup when the DAMZ page is closed
 */
function* handlePageClose() {
  // Reset the drawer filter to all
  yield put(clearAllDrawerStreams());
  yield put(setDrawerFilter('all'));

  // Clear the active room item, so we don't keep marking it read etc
  yield put(clearActiveRoomItem());

  // cleanup title, hacky way until we have react 19 and native head management
  if (document.title.includes('Messages')) {
    yield delay(200);
    document.title = 'DeviantArt - Discover The Largest Online Art Gallery and Community';
  }
}

/**
 * Page cleanup saga that listens for duperbrowse exit events
 */
export function* pageCleanupSaga() {
  yield takeEvery(exitDuperbrowseDone, handlePageClose);
}
